import React from 'react';
import Icon from "../Icon";
import svgIcon from '../../svgs/check.svg';

export default class Checkbox extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<div className='box-container'>
            <div
                className={`checkbox-container ${this.props.type === 'uncheckable' && 'disabled'}`}
                onClick={() => {
                    if (this.props.type !== 'uncheckable')
                        this.props.handleClick(this.props.name)
                }}>
                {
                    this.props.type === 'checkable' &&
                    <div
                        className={`checkbox-button checkable ${this.props.isSelected ? 'checked' : ''}`}>
                        {
                            this.props.isSelected &&
                            <div className='icon'>
                                <Icon svg={svgIcon}/>
                            </div>
                        }
                    </div>
                }

                {
                    this.props.type === 'uncheckable' && <div
                        className={`checkbox-button uncheckable ${this.props.darkMode && 'dark'} ${this.props.isSelected && 'selected'}`}>
                        {
                            this.props.isSelected &&
                            <div className='icon'>
                                <Icon svg={svgIcon}/>
                            </div>
                        }
                    </div>
                }

                <div className={`text ${this.props.type === 'uncheckable' ? 'disabled' : ''} ${this.props.darkMode === true && 'dark'}`}>{this.props.text}</div>
            </div>
        </div>)
    }
}
